<p id="title" class="headline-small">{{ 'addMember.title' | translate }} </p>
<mat-dialog-content id="content">
  <div class="flexColumnContainer">
    <span id="text" class="body-medium">{{ 'addMember.text' | translate }}</span>
    <mat-form-field>
      <mat-label>{{ 'addMember.email.label' | translate }}</mat-label>
      <input matInput type="email" [placeholder]="'addMember.email.placeholder' | translate" aria-label="Email"
             [formControl]="emailFormControl" (keydown.enter)="onEnter()">
      <mat-icon matPrefix class="material-icons-outlined">person_add</mat-icon>
      @if (emailFormControl.hasError('email')) {
        <mat-error>{{ 'addMember.email.errorMessage' | translate }}</mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'addMember.buttons.cancel' | translate }}</button>
  <button id="confirmation" mat-flat-button [disabled]="!emailFormControl.valid || emailFormControl.value === ''"
          [mat-dialog-close]="emailFormControl.value">{{ 'addMember.buttons.confirm' | translate }}
  </button>
</mat-dialog-actions>
